import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AttendeeModalPageRoutingModule } from './attendee-modal-routing.module';

import { AttendeePage } from './attendee-modal.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    AttendeeModalPageRoutingModule
  ],
  declarations: [AttendeePage],
  exports: [AttendeePage]
})
export class AttendeeModalPageModule {}
